module.exports = __webpack_public_path__ + "img/clienteavalize.44a85827.png";